<template>
  <div class="role-manage-box outer-page-primary">
    <div class="header-box">
      <div class="title-box">
        <div class="symbol" />
        <div class="title">角色列表</div>
      </div>
    </div>
    <div class="operation-box">
      <div class="common-button-box">
        <el-button
          class="primary-btn"
          v-if="isChecked('Role.Create')"
          size="small"
          type="primary"
          @click="openRoleDialog">
          新增角色
        </el-button>
        <el-button
          class="normal-btn"
          v-if="isChecked('Role.Delete')"
          size="small"
          @click="batchDeleteRole">
          删除角色
        </el-button>
      </div>
      <div class="common-input-box">
        <el-input
          class="input-primary"
          size="small"
          placeholder="请输入角色名称"
          v-model="keywords"
          clearable
          @clear="search"
          @keyup.enter.native="search">
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="search" />
        </el-input>
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        :data="roleList"
        class="publish-table"
        highlight-selection-row
        :header-row-class-name="customHeaders"
        @select="selectChange"
        @select-all="selectChange"
        height="100%"
        ref="groupTable">
        <el-table-column
          type="selection"
          width="60" />
        <el-table-column
          label="角色名称"
          prop="roleName">
          <template v-slot="{ row }">
            <div class="role-name-box">
              <div class="text-overflow">
                {{ row.roleName }}
              </div>
              <div
                class="defult-role-box"
                v-if="row.isDefault">
                默认角色
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="角色编码"
          prop="roleCode" />
        <el-table-column
          label="角色级别"
          prop="roleLevelName" />
        <el-table-column
          label="角色范围"
          prop="roleScopeName" />
        <el-table-column
          label="用户范围"
          prop="userScopeName" />
        <el-table-column
          label="项目范围"
          prop="projScopeName" />
        <el-table-column
          label="构件范围"
          prop="entityScopeName" />
        <el-table-column label="角色说明">
          <template v-slot="{ row }">
            <div
              class="two-line-text-overflow"
              :title="row.description">
              {{ row.description }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="280"
          v-if="isActionColumnVisible()">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                v-if="isChecked('Role.Update')"
                @click="editRole(row)"
                type="text"
                size="small">
                编辑角色
              </el-button>
              <el-button
                v-if="isChecked('Permission.RoleGrant')"
                @click="openRolePermissionDialog(row)"
                type="text"
                size="small">
                角色权限
              </el-button>
              <el-button
                v-if="isChecked('Role.Delete')"
                type="text"
                size="small"
                @click="deleteRole(row)">
                删除角色
              </el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="empty-box">
            <!-- <bj-empty
              class="empty-page">
              <template slot="description">没有找到角色</template>
              <div class="common-button-box">
                <el-button
                  v-if="isChecked('Role.Create')"
                  type="primary"
                  size="small"
                  @click="openRoleDialog">
                  新增角色
                </el-button>
              </div>
            </bj-empty> -->
          </div>
        </template>
      </el-table>
    </div>
    <RoleDialog
      :visible="roleDialogVisible"
      :roleInfo="roleInfo"
      :updateRoleList="updateRoleList"
      :closeDialog="closeRoleDialog" />
    <RolePermissionDialog
      :visible="rolePermissionDialogVisible"
      :roles="configRoles"
      :closeDialog="closeRolePermissionDialog" />
  </div>
</template>

<script>
import RoleDialog from './components/RoleDialog.vue'
import RolePermissionDialog from './components/RolePermissionDialog.vue'

import { Store } from '@/utils/store'

import {
  getRoleListService,
  deleteRoleCheckService,
  deleteRoleService,
  batchDeleteRoleService
} from '@/service/interface'

export default {
  data() {
    return {
      keywords: '',
      roleList: [],
      selectRoles: [],
      configRoles: [],
      roleInfo: null,
      customHeaders: '',
      roleDialogVisible: false,
      editRoloeFlag: false,

      rolePermissionDialogVisible: false
    }
  },
  components: { RoleDialog, RolePermissionDialog },
  created() {
    this.initRoleList()
  },
  mounted() {
    const currentBody = this.$refs.groupTable?.bodyWrapper
    const _this = this
    currentBody &&
      currentBody.addEventListener('scroll', ev => {
        const scrollTop = ev.target.scrollTop
        _this.customHeaders = scrollTop > 10 ? 'darkHeader' : ''
      })
  },
  methods: {
    initRoleList() {
      this.queryRoleList().then(roleList => {
        this.roleList = roleList
      })
    },
    updateRoleList() {
      return new Promise(resolve => {
        this.queryRoleList().then(roleList => {
          this.roleList = roleList
          resolve()
        })
      })
    },
    search() {
      this.queryRoleList().then(roleList => {
        this.roleList = roleList
      })
    },
    openRoleDialog() {
      this.roleDialogVisible = true
    },
    openRolePermissionDialog(roleInfo) {
      this.configRoles = [roleInfo]
      this.rolePermissionDialogVisible = true
    },
    deleteRole(roleInfo) {
      let roleIds = [roleInfo.roleId]
      deleteRoleCheckService({ roleIds }).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            this.$confirm('确定删除该角色?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.deleteRolePromise(roleIds).then(() => {
                  this.queryRoleList().then(roleList => {
                    this.roleList = roleList
                    this.$message.success('删除成功!')
                  })
                })
              })
              .catch(() => {
                // this.$message.info('取消删除!')
              })
          } else {
            this.$confirm(response.errMsg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          }
        }
      })
    },
    batchDeleteRole() {
      if (!this.selectRoles.length) {
        this.$message.warning('请选择需要删除的角色！！！')
        return
      }

      let roleIds = this.selectRoles.map(el => el.roleId)
      deleteRoleCheckService({ roleIds }).then(result => {
        if (result.status === 200) {
          let response = result.data
          if (response.isSuccess) {
            let errMsg = response.errMsg
            if (errMsg) {
              this.$confirm(errMsg, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  roleIds = response.data
                  this.deleteRolePromise(roleIds).then(() => {
                    this.queryRoleList().then(roleList => {
                      this.roleList = roleList
                      this.$message.success('删除成功!')
                    })
                  })
                })
                .catch(() => {
                  // this.$message.info('取消删除!')
                })
            } else {
              this.$confirm('确定删除这些角色?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
                .then(() => {
                  this.deleteRolePromise(roleIds).then(() => {
                    this.queryRoleList().then(roleList => {
                      this.roleList = roleList
                      this.$message.success('删除成功!')
                    })
                  })
                })
                .catch(() => {
                  // this.$message.info('取消删除!')
                })
            }
          } else {
            this.$confirm(response.errMsg, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
          }
        }
      })
    },
    deleteRolePromise(roleIds) {
      return new Promise(resolve => {
        if (roleIds.length === 1) {
          let roleId = roleIds[0]
          deleteRoleService(roleId).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                resolve()
              }
            }
          })
        } else {
          batchDeleteRoleService(roleIds).then(result => {
            if (result.status === 200) {
              let response = result.data
              if (response.isSuccess) {
                resolve()
              }
            }
          })
        }
      })
    },
    selectChange(selection) {
      this.selectRoles = selection
    },
    editRole(roleInfo) {
      this.roleInfo = roleInfo
      this.roleDialogVisible = true
    },
    closeRoleDialog() {
      this.roleInfo = null
      this.roleDialogVisible = false
    },
    closeRolePermissionDialog() {
      this.roleInfo = null
      this.rolePermissionDialogVisible = false
    },
    queryRoleList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: 1000,
          skipCount: 0,
          sorting: '',
          roleName: this.keywords
        }
        getRoleListService(params).then(result => {
          if (result.status === 200) {
            let response = result.data
            if (response.isSuccess) {
              let data = response.data
              let roleList = this.formatRoleData(data.items)
              resolve(roleList)
            } else {
              this.$message.error(response.errMsg)
            }
          }
        })
      })
    },
    formatRoleData(roleList) {
      const roleLevelList = [
        { value: 1, label: '一级' },
        { value: 2, label: '二级' },
        { value: 3, label: '三级' },
        { value: 4, label: '四级' },
        { value: 5, label: '五级' },
        { value: 6, label: '六级' },
        { value: 7, label: '七级' },
        { value: 8, label: '八级' },
        { value: 9, label: '九级' },
        { value: 10, label: '十级' }
      ]

      const roleScopeList = [
        { value: 1, label: '所有角色' },
        { value: 2, label: '子级角色' },
        { value: 3, label: '无' }
      ]

      const userScopeList = [
        { value: 1, label: '所有用户' },
        { value: 2, label: '子级角色用户' },
        { value: 3, label: '子级用户' },
        { value: 4, label: '无' }
      ]

      const projScopeList = [
        { value: 1, label: '所有项目' },
        { value: 2, label: '子级用户项目' },
        { value: 3, label: '仅授权项目' }
      ]

      const entityScopeList = [
        { value: 1, label: '所有构件' },
        { value: 2, label: '我的构件' }
      ]

      roleList.forEach(item => {
        let roleLevelFind = roleLevelList.find(
          el => el.value === item.roleLevel
        )
        item.roleLevelName = roleLevelFind ? roleLevelFind.label : '--'

        let roleScopeFind = roleScopeList.find(
          el => el.value === item.roleScope
        )
        item.roleScopeName = roleScopeFind ? roleScopeFind.label : '--'

        let userScopeFind = userScopeList.find(
          el => el.value === item.userScope
        )
        item.userScopeName = userScopeFind ? userScopeFind.label : '--'

        let projScopeFind = projScopeList.find(
          el => el.value === item.projectScope
        )
        item.projScopeName = projScopeFind ? projScopeFind.label : '--'

        let entityScopeFind = entityScopeList.find(
          el => el.value === item.componentScope
        )
        item.entityScopeName = entityScopeFind ? entityScopeFind.label : '--'
      })

      return roleList
    },
    isActionColumnVisible() {
      let visible = true
      // prettier-ignore
      if (!this.isChecked('Role.Update') && !this.isChecked('Permission.RoleGrant') && !this.isChecked('Role.Delete')) {
        visible = false;
      }
      return visible
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
@import '@/assets/css/pageStyle.less';
.role-manage-box {
  height: 100%;

  .header-box {
    display: flex;
    justify-content: space-between;
    text-align: left;

    .title-box {
      display: flex;
      align-items: center;

      .symbol {
        width: 4px;
        height: 20px;
        background: var(--base-primary-bgColor);
      }

      .title {
        margin-left: 10px;
        color: var(--page-title-color);
      }
    }
  }

  .operation-box {
    display: flex;
  }

  .common-table-box {
    height: calc(100% - 124px);
    padding: 0 16px;

    .role-name-box {
      display: flex;
      align-items: center;

      .defult-role-box {
        flex-shrink: 0;
        margin-left: 10px;
        height: 20px;
        line-height: 17px;
        padding: 0 4px;
        font-size: 12px;
        color: var(--base-primary-bgColor);
        background: var(--base-bg-light-color24);
        border-radius: 4px;
        border: 1px solid var(--base-primary-bgColor);
      }
    }

    .two-line-text-overflow {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 1.5em;
    }

    .common-button-box {
      display: flex;
      justify-content: center;
      margin-top: 12px;

      .el-button {
        margin-right: 0px;
      }
    }
  }
}
</style>
